export default __webpack_public_path__ + "static/media/beck.026bb61b.png";